import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CarrouselProducts from 'components/commons/CarrouselProducts';
import BrandHeroCarousel from 'components/commons/BrandHeroCarousel';
import { isSlideImage, useRenderableHeroSliders } from 'helpers/sliders';
import './HomeTextil.scss';

const HomeTextil = ({
  cartel,
  sliders,
  categoriesHome,
  mostSelled,
  featuredProducts,
  renderItem
}) => {
  const redirectCartel = (numeroCartel) => {
    if(cartel[numeroCartel].subcategory_id !== null){
      return `/productos/${cartel[numeroCartel].category.code}/${cartel[numeroCartel].subcategory.code}`;
    }
    else{
      return `/productos/${cartel[numeroCartel].category.code}`;
    }
  }
  const {
    heroSliders,
    markHeroSlideReady,
    markHeroSlideFailed,
  } = useRenderableHeroSliders(sliders);
  const [activeHeroSlide, setActiveHeroSlide] = useState(0);

  useEffect(() => {
    if (activeHeroSlide >= heroSliders.length) setActiveHeroSlide(0);
  }, [activeHeroSlide, heroSliders.length]);

  const showHeroSlide = useCallback((index) => {
    if (!heroSliders.length) return;
    setActiveHeroSlide((index + heroSliders.length) % heroSliders.length);
  }, [heroSliders.length]);

  const showNextHeroSlide = useCallback(() => {
    if (!heroSliders.length) return;
    setActiveHeroSlide((current) => (current + 1) % heroSliders.length);
  }, [heroSliders.length]);

  useEffect(() => {
    const activeSlide = heroSliders[activeHeroSlide];
    if (!activeSlide || !isSlideImage(activeSlide) || heroSliders.length < 2) return undefined;

    const timer = window.setTimeout(showNextHeroSlide, 6000);
    return () => window.clearTimeout(timer);
  }, [activeHeroSlide, heroSliders, showNextHeroSlide]);

  const renderHeroMedia = (slide) => (
    <div key={slide.id || slide.image} className="hero-slide">
      {isSlideImage(slide) ? (
        <img
          src={slide.image}
          alt={slide.text}
          loading="eager"
          decoding="async"
          onLoad={() => markHeroSlideReady(slide)}
          onError={() => markHeroSlideFailed(slide)}
        />
      ) : (
        <video
          src={slide.image}
          autoPlay
          muted
          loop={heroSliders.length === 1}
          playsInline
          preload="auto"
          onLoadedData={() => markHeroSlideReady(slide)}
          onError={() => markHeroSlideFailed(slide)}
          onCanPlay={(event) => {
            event.currentTarget.muted = true;
            const playRequest = event.currentTarget.play();
            if (playRequest) playRequest.catch(() => {});
          }}
          onEnded={heroSliders.length > 1 ? showNextHeroSlide : undefined}
        />
      )}
    </div>
  );

  return (
    <div className="home home-textil">
      {/* Hero */}
      {heroSliders.length > 1 && (
        <BrandHeroCarousel sliders={sliders} variant="design-3" />
      )}
      {!!heroSliders.length && heroSliders.length === 1 && (
        <div className="hero-image hero-carousel">
          {renderHeroMedia(heroSliders[activeHeroSlide] || heroSliders[0])}
          {heroSliders.length > 1 && (
            <>
              <button
                type="button"
                className="hero-media-nav hero-media-nav--prev"
                aria-label="Anterior"
                onClick={() => showHeroSlide(activeHeroSlide - 1)}
              >
                <i className="fa fa-chevron-left" aria-hidden="true" />
              </button>
              <button
                type="button"
                className="hero-media-nav hero-media-nav--next"
                aria-label="Siguiente"
                onClick={showNextHeroSlide}
              >
                <i className="fa fa-chevron-right" aria-hidden="true" />
              </button>
              <div className="hero-media-dots" aria-label="Portadas">
                {heroSliders.map((slide, index) => (
                  <button
                    key={slide.id || slide.image}
                    type="button"
                    className={index === activeHeroSlide ? 'is-active' : ''}
                    aria-label={`Ver portada ${index + 1}`}
                    aria-current={index === activeHeroSlide ? 'true' : undefined}
                    onClick={() => showHeroSlide(index)}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {/* Categorías */}
      <section className="categories-section">
        <h2 className="section-title">Nuestras Categorías</h2>
        <p className="section-subtitle">Descubri nuestra amplia seleccion de productos</p>
        <div className="categories-grid">
          {categoriesHome.slice(0, 4).map(({ category }) => (
            <Link
              key={category.id}
              to={`/productos/${category.code}`}
              className="category-card"
            >
              <img src={category.imageHome} alt={category.name} />
              <div className="card-overlay">
                <span>{category.name}</span>
                <button type="button">Ver más</button>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <div className='section'>
        {cartel[0] && (
          <div className="imgCartel-wrapper">
            <img 
              src={cartel[0].image} 
              alt="Banner" 
              className="imgCartel-full" 
            />
            <div className="infoCartel-overlay">
              <div className="description-container">
                <Link to={redirectCartel(0)}>
                  <button type="button">Ver Colección</button>
                </Link>
              </div>
            </div>
          </div>
        )}
        {cartel[1] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[1].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(1)}><button type="button">Ver Colección</button></Link>
              </div>
            </div>
          </div>
        )}
        {cartel[2] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[2].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(2)}><button type="button">Ver Colección</button></Link>
              </div>
            </div>
          </div>
        )}
        {cartel[3] && (
          <div className="imgCartel" style={{ backgroundImage: `url(${cartel[3].image})` }}>
            <div className="infoCartel">
              <div className="description-container row">
                <Link to={redirectCartel(3)}><button type="button">Ver Colección</button></Link>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Más vendidos */}
      <section className="favorites-section">
        <span className="badge-small">⭐ MÁS VENDIDOS</span>
        <h2 className="section-title">Favoritos de Nuestros Clientes</h2>
        <p className="section-subtitle">Calidad y versatilidad</p>
        <div className="product-list">
          {mostSelled.map(renderItem)}
        </div>
      </section>

      {/* Destacados */}
      <section className="featured-section">
        <h2 className="section-title">Productos Destacados</h2>
        <p className="section-subtitle">Los más vendidos con los mejores precios</p>
        <div className="product-list">
          {featuredProducts.map(renderItem)}
        </div>
      </section>
    </div>
  )
};

export default HomeTextil;
